<template>
  <div class="goodList" :class="{ 'card-mode': isCard }">
    <div
      v-if="isCard"
      class="card-list acea-row row-between-wrapper"
    >
      <div
        @click="goDetail(item)"
        v-for="(item, index) in goodList"
        :key="index"
        class="card-item"
      >
        <div class="pictrue">
          <img v-lazy="item.image" alt="img" class="image" />
          <span
            class="pictrue_log_class pictrue_log_big"
            v-if="item.activity && item.activity.type === '1'"
            >秒杀</span
          >
          <span
            class="pictrue_log_class pictrue_log_big"
            v-if="item.activity && item.activity.type === '2'"
            >砍价</span
          >
          <span
            class="pictrue_log_class pictrue_log_big"
            v-if="item.activity && item.activity.type === '3'"
            >拼团</span
          >
        </div>
        <div class="text">
          <div class="name">{{ item.store_name }}</div>
          <div class="money font-color-red">
            ￥<span class="num">{{ item.price }}</span>
          </div>
          <div class="vip-row acea-row row-between-wrapper">
            <div class="vip-money" v-if="item.vip_price && item.vip_price > 0">
              ￥{{ item.vip_price || 0
              }}<img src="@assets/images/vip.png" class="image" />
            </div>
            <div class="sales">已售{{ item.sales }}{{ item.unit_name || "件" }}</div>
          </div>
        </div>
      </div>
    </div>
    <template v-else>
      <div
        @click="goDetail(item)"
        v-for="(item, index) in goodList"
        :key="index"
        class="item acea-row row-between-wrapper"
      >
        <div class="pictrue">
          <img v-lazy="item.image" alt="img" class="image" />
          <span
            class="pictrue_log pictrue_log_class"
            v-if="item.activity && item.activity.type === '1'"
            >秒杀</span
          >
          <span
            class="pictrue_log pictrue_log_class"
            v-if="item.activity && item.activity.type === '2'"
            >砍价</span
          >
          <span
            class="pictrue_log pictrue_log_class"
            v-if="item.activity && item.activity.type === '3'"
            >拼团</span
          >
        </div>
        <div class="underline">
          <div class="text">
            <div class="line1">{{ item.store_name }}</div>
            <div class="money font-color-red">
              ￥<span class="num">{{ item.price }}</span>
            </div>
            <div class="vip-money acea-row row-middle">
              <div class="vip" v-if="item.vip_price && item.vip_price > 0">
                ￥{{ item.vip_price || 0
                }}<img src="@assets/images/vip.png" class="image" />
              </div>
              <span class="num">已售{{ item.sales }}{{ item.unit_name }}</span>
            </div>
          </div>
        </div>
        <div
          class="iconfont icon-gouwuche cart-color acea-row row-center-wrapper"
        ></div>
      </div>
    </template>
  </div>
</template>
<script>
import { goShopDetail } from "@libs/order";
export default {
  name: "GoodList",
  props: {
    goodList: {
      type: Array,
      default: () => []
    },
    isSort: {
      type: Boolean,
      default: true
    },
    isCard: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {};
  },
  methods: {
    goDetail(item) {
      goShopDetail(item).then(() => {
        if (item.id == 57 || item.id == 60) {
          this.$router.push({ path: "/deposit/" + item.id });
        } else {
          this.$router.push({ path: "/detail/" + item.id });
        }
      });
    }
  }
};
</script>
<style scoped>
.goodList.card-mode {
  background-color: #f5f5f5;
  padding-bottom: 0.2rem;
}

.goodList.card-mode .card-list {
  flex-wrap: wrap;
  padding: 0 0.2rem 0.1rem;
}

.goodList.card-mode .card-item {
  width: 3.45rem;
  margin-top: 0.2rem;
  background-color: #fff;
  border-radius: 0.1rem;
  overflow: hidden;
}

.goodList.card-mode .card-item .pictrue {
  width: 100%;
  height: 3.45rem;
  position: relative;
}

.goodList.card-mode .card-item .pictrue .image {
  width: 100%;
  height: 100%;
  border-radius: 0.1rem 0.1rem 0 0;
}

.goodList.card-mode .card-item .text {
  padding: 0.2rem 0.17rem 0.26rem;
  font-size: 0.3rem;
  color: #222;
  text-align: left;
}

.goodList.card-mode .card-item .text .name {
  white-space: normal;
  word-break: break-word;
  line-height: 1.4;
  font-size: 0.28rem;
}

.goodList.card-mode .card-item .text .money {
  font-size: 0.26rem;
  font-weight: bold;
  margin-top: 0.08rem;
}

.goodList.card-mode .card-item .text .money .num {
  font-size: 0.34rem;
}

.goodList.card-mode .card-item .text .vip-row {
  font-size: 0.22rem;
  color: #aaa;
  margin-top: 0.07rem;
}

.goodList.card-mode .card-item .text .vip-money {
  font-size: 0.24rem;
  color: #282828;
  font-weight: bold;
}

.goodList.card-mode .card-item .text .vip-money .image {
  width: 0.46rem;
  height: 0.21rem;
  margin-left: 0.04rem;
}

.goodList.card-mode .card-item .text .sales {
  font-size: 0.22rem;
  color: #aaa;
}
</style>
